import { Button } from '../Default Button/Button';
import { reemaColors } from '../../../theme/colors';
import { ReactNode } from 'react';

export interface SectionLinkButtonProps {
  /**
   * Variant of the button
   * @default 'text'
   */
  variant?: 'text' | 'outlined' | 'contained';
  /**
   * An icon to display at the start of the button
   * @default null
   */
  startIcon?: ReactNode;
  /**
   * The content of the button; nullable if only using
   * a 'startIcon' as the content
   */
  children?: React.ReactNode;
  /**
   * Object containing sx styles
   */
  sx?: {
    borderRadius?: number;
    boxShadow?: number;
    textDecoration?: string;
    backgroundColor?: string;
    borderColor?: string;
    '&:hover': {
      backgroundColor?: string;
      borderColor?: string;
    };
  };
  /**
   * The function to call when the button is clicked
   *
   * @param args anything that is passed to the onClick function
   * @returns void
   */
  onClick: (args) => void;
  /**
   * Optional tracking name for DataDog tracking. If not provided, defaults to 'section-link-button'
   */
  trackingName?: string;
}

export const sxDefaults = {
  borderRadius: 2,
  boxShadow: 1,
  textDecoration: 'underline',
  backgroundColor: reemaColors.lightBackground,
  borderColor: 'white',
  '&:hover': {
    backgroundColor: reemaColors.lightGray,
    borderColor: 'transparent',
  },
};

export const SectionLinkButton = ({
  startIcon,
  onClick,
  children,
  variant = 'text',
  sx = sxDefaults,
  trackingName,
}: SectionLinkButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      startIcon={startIcon}
      sx={sx}
      trackingName={trackingName || 'section-link-button'}
    >
      {children}
    </Button>
  );
};
